import { Controller } from '@hotwired/stimulus'

export default class WorkordersCarouselController extends Controller {
  static values = {
    currentIndex: Number,
    itemsCount: Number,
    autoplayInterval: Number
  }

  connect () {
    this.showSlide(this.currentIndexValue)
    this.startAutoplay()
  }

  disconnect () {
    this.stopAutoplay()
  }

  showSlide (index) {
    for (let i = 0; i < this.itemsCountValue; i++) {
      const el = document.getElementById(`carousel-item-${i}`)
      if (el) el.classList.add('hidden')

      const dot = document.getElementById(`carousel-indicator-${i}`)
      if (dot) {
        dot.classList.remove('bg-primary-300')
        dot.classList.add('bg-gray-300')
      }
    }

    const currentEl = document.getElementById(`carousel-item-${index}`)
    if (currentEl) currentEl.classList.remove('hidden')

    const activeDot = document.getElementById(`carousel-indicator-${index}`)
    if (activeDot) {
      activeDot.classList.remove('bg-gray-300')
      activeDot.classList.add('bg-primary-300')
    }
  }

  nextSlide () {
    this.currentIndexValue = (this.currentIndexValue + 1) % this.itemsCountValue
    this.showSlide(this.currentIndexValue)
  }

  prevSlide () {
    this.currentIndexValue =
      (this.currentIndexValue - 1 + this.itemsCountValue) % this.itemsCountValue
    this.showSlide(this.currentIndexValue)
  }

  goToSlide (event) {
    const index = parseInt(event.params.goToSlide) % this.itemsCountValue
    if (!isNaN(index)) {
      this.currentIndexValue = index
      this.showSlide(index)
    }
  }

  startAutoplay () {
    this.stopAutoplay()
    this.timer = setInterval(() => {
      this.nextSlide()
    }, this.autoplayIntervalValue || 5000)
  }

  stopAutoplay () {
    if (this.timer) clearInterval(this.timer)
  }
}
